<script setup>
import {useBaseStore} from "~/stores/base";
import star10Percent from "@/assets/img/icon-star-10-percent.svg"
import star20Percent from "@/assets/img/icon-star-20-percent.svg"
import star30Percent from "@/assets/img/icon-star-30-percent.svg"
import star40Percent from "@/assets/img/icon-star-40-percent.svg"
import star50Percent from "@/assets/img/icon-star-50-percent.svg"
import star60Percent from "@/assets/img/icon-star-60-percent.svg"
import star70Percent from "@/assets/img/icon-star-70-percent.svg"
import star80Percent from "@/assets/img/icon-star-80-percent.svg"
import star90Percent from "@/assets/img/icon-star-90-percent.svg"
import star100Percent from "@/assets/img/icon-star-filled.svg"

const router = useRouter()
const route = useRoute()

/** props **/
const props = defineProps({
  product: {
    default: {},
    required: true
  }
})

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const fullStars = computed(() => Math.floor(props.product.reviewAverage || 0))
const hasHalfStar = computed(() => props.product.reviewAverage % 1 >= 0.5)
const halfStarImg = computed(() => {
  const percent = Math.round(props.product.reviewAverage % 1 * 10) * 10
  switch (percent) {
    case 10:
      return star10Percent
    case 20:
      return star20Percent
    case 30:
      return star30Percent
    case 40:
      return star40Percent
    case 50:
      return star50Percent
    case 60:
      return star60Percent
    case 70:
      return star70Percent
    case 80:
      return star80Percent
    case 90:
      return star90Percent
    case 100:
      return star100Percent
  }
})
const emptyStars = computed(() => 5 - fullStars.value - (hasHalfStar.value ? 1 : 0))

const handleClick = () => {
  router.replace({
    path: router.currentRoute.value.path,
    query: router.currentRoute.value.query, // 保留查询参数
    hash: '#reviews-all'
  });
}
</script>

<template>
  <div class="module-product-rate-mobile" v-if="isMobile">
    <div class="stars">
      <img src="@/assets/img/icon-star-filled.svg" alt="star" v-for="star in fullStars">
      <img :src="halfStarImg" alt="star" v-if="hasHalfStar">
      <img src="@/assets/img/icon-star-empty.svg" alt="star" v-for="star in emptyStars">
    </div>
    <div class="points">{{ product.reviewAverage }}</div>
    <div class="divider"> /</div>
    <div class="reviews" @click="handleClick">{{ product.reviewCount }} reviews</div>
  </div>
  <div class="module-product-rate-desktop" v-else>
    <div class="stars">
      <img src="@/assets/img/icon-star-filled.svg" alt="star" v-for="star in fullStars">
      <img :src="halfStarImg" alt="star" v-if="hasHalfStar">
      <img src="@/assets/img/icon-star-empty.svg" alt="star" v-for="star in emptyStars">
    </div>
    <div class="points">{{ product.reviewAverage }}</div>
    <div class="divider"> /</div>
    <div class="reviews" @click="handleClick">{{ product.reviewCount }} reviews</div>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.module-product-rate-mobile {
  padding: 0 16px;
  margin-top: 5px;

  display: flex;
  align-items: center;

  .stars {
    display: flex;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .points {
    margin-left: 8px;
    font-family: "TWK Lausanne";
    font-weight: 650;
    font-size: 12px;
    font-style: normal;
    line-height: 18px; /* 150% */
  }

  .divider {
    margin: 0 8px;
    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }

  .reviews {
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
    text-decoration-line: underline;
    cursor: pointer;
  }
}

.module-product-rate-desktop {
  margin-top: 24px;

  display: flex;
  align-items: center;

  .stars {
    display: flex;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .points {
    margin-left: 8px;
    font-family: "TWK Lausanne";
    font-weight: 650;
    font-size: 12px;
    font-style: normal;
    line-height: 18px; /* 150% */
  }

  .divider {
    margin: 0 8px;
    /* Text xs/Regular */
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
  }

  .reviews {
    font-family: "TWK Lausanne";
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 150% */
    text-decoration-line: underline;
    cursor: pointer;
  }
}
</style>
